import {  Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "./Home";
import Contact from "./Contact";
import './App.css'
import Header from "./components/Header";
import Footer from "./components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // for Navbar toggle
import AepsService from "./components/AepsService";
import BBPS from "./components/BBPSService";
import Upiatm from "./components/Upiatm";
import ITTechnology from "./components/ITTechnology";
import TaxationServices from "./components/TaxationService";
import ATMMicro from "./components/ATMMicro";
import BusinessLegal from "./components/BusinessLegal";
import AadhaarPay from "./components/AadhaarPay";
import APIIntegration from "./components/APIIntergationService";
import ATMInstallation from "./components/ATMInstallation";
import RegistationServices from "./components/RegistationServices";
import ScrollToTop from "./components/ScrollToTop";
import TermsandConditions from "./components/TermsandConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";


function App() {

  return (
    <div className="responsive-section">
      <ScrollToTop />
      <ToastContainer />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />

         {/* SERVICE DROPDOWN ROUTES */}
         <Route path="/service/aepsservice" element={<AepsService />} />
         <Route path="/service/bbpsservice" element={<BBPS />} />
         <Route path="/service/upiatmservice" element={<Upiatm/>} />
          <Route path="/service/ittechnology" element={<ITTechnology/>} />
         <Route path="/service/taxationservices" element={<TaxationServices/>} />
         <Route path="/service/microatmservices" element={<ATMMicro/>} />
         <Route path="/service/atminstallation" element={<ATMInstallation/>} />
         <Route path="/service/businesslegal" element={<BusinessLegal/>} />
          <Route path="/service/registationservices" element={<RegistationServices/>} />
         <Route path="/service/aadharpayservices" element={<AadhaarPay/>} />
         <Route path="/service/apiintegration" element={<APIIntegration/>} />

         <Route path="/terms-and-conditions" element={<TermsandConditions />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/contact" element={<Contact />  } />
      </Routes>
      <Footer />
    </div>
  );
}

export default App
